import api from '@/lib/axios';
import { API_ENDPOINTS } from '@/constants/api-endpoints';

export interface PaymentRecord {
  id: string;
  amount: string;
  payment_method: string;
  payment_status: string;
  transaction_id: string | null;
  razorpay_order_id: string | null;
  razorpay_payment_id: string | null;
  driver_earnings: string | null;
  created_at: string;
  booking?: {
    id: string;
    pickup_address: string;
    drop_address: string;
    customer?: { id: string; name: string; phone: string };
    driver?: { id: string; name: string; phone: string };
  };
}

export interface WithdrawalRecord {
  id: string;
  amount: string;
  status: 'pending' | 'processing' | 'completed' | 'rejected';
  remarks: string | null;
  created_at: string;
  updated_at: string;
  driver_profile?: {
    id: string;
    user_id: string;
    user?: { name: string; phone: string };
  };
  bank_account?: {
    account_holder_name: string;
    bank_name: string;
    account_number: string;
    ifsc_code: string;
  };
}

export const paymentsApi = {
  getAll: async (params: { page?: number; limit?: number; status?: string; search?: string }) => {
    const res = await api.get(API_ENDPOINTS.PAYMENTS.LIST, { params });
    const raw = (res.data as any)?.data ?? res.data;
    return {
      payments: raw.payments ?? [],
      total: raw.total ?? 0,
      page: raw.page ?? 1,
      pages: raw.pages ?? 1,
    };
  },

  getWithdrawals: async (status?: string) => {
    const res = await api.get(API_ENDPOINTS.WITHDRAWALS.LIST, {
      params: status && status !== 'all' ? { status } : undefined,
    });
    const raw = (res.data as any)?.data ?? res.data;
    return Array.isArray(raw) ? raw : (raw.withdrawals ?? []);
  },

  approveWithdrawal: async (id: string, remarks?: string): Promise<void> => {
    await api.put(API_ENDPOINTS.WITHDRAWALS.APPROVE(id), { remarks });
  },

  rejectWithdrawal: async (id: string, remarks?: string): Promise<void> => {
    await api.put(API_ENDPOINTS.WITHDRAWALS.REJECT(id), { remarks });
  },
};
